import React from "react";

import {
  getServicesPricingOfferingIconPresentation,
  type ServicesPricingOfferingIconKey,
} from "./profileServicesPricingOfferingIcons";

export type ServicesPricingOfferingIconProps = Readonly<{
  className?: string;
  iconKey: ServicesPricingOfferingIconKey;
}>;

export function ServicesPricingOfferingIcon({
  className,
  iconKey,
}: ServicesPricingOfferingIconProps) {
  const presentation = getServicesPricingOfferingIconPresentation(iconKey);
  const sharedProps = {
    className,
    fill: "none",
    stroke: presentation.color,
    strokeWidth: 1.8,
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
    viewBox: "0 0 24 24",
    "aria-hidden": true as const,
  };

  switch (iconKey) {
    case "box":
      return (
        <svg {...sharedProps}>
          <path d="M12 3 4 7.5v9L12 21l8-4.5v-9L12 3Z" />
          <path d="M12 12 4 7.5M12 12l8-4.5M12 12v9" />
        </svg>
      );
    case "thermometer":
      return (
        <svg {...sharedProps}>
          <path d="M14 14.76V5a2 2 0 0 0-4 0v9.76a4 4 0 1 0 4 0Z" />
        </svg>
      );
    case "video":
      return (
        <svg {...sharedProps}>
          <path d="m16 13 5-3v8l-5-3v-2Z" />
          <rect x="3" y="6" width="13" height="12" rx="2" />
        </svg>
      );
    case "camera":
      return (
        <svg {...sharedProps}>
          <path d="M4 8h3.5L9 6h6l1.5 2H20v10H4V8Z" />
          <circle cx="12" cy="13" r="3" />
        </svg>
      );
    case "tractor":
      return (
        <svg {...sharedProps}>
          <path d="M5 17h12M7 17a2 2 0 1 0 0 .01M17 17a2 2 0 1 0 0 .01M5 13h4l2-4h5l2 4h1" />
          <path d="M9 9V6h4v3" />
        </svg>
      );
    case "building":
      return (
        <svg {...sharedProps}>
          <path d="M6 20V6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v14" />
          <path d="M9 9h2M9 13h2M13 9h2M13 13h2M4 20h16" />
        </svg>
      );
    case "eye":
      return (
        <svg {...sharedProps}>
          <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z" />
          <circle cx="12" cy="12" r="3" />
        </svg>
      );
    case "map":
    default:
      return (
        <svg {...sharedProps}>
          <path d="M9 4 3 6v14l6-2 6 2 6-2V4l-6 2-6-2Z" />
          <path d="M9 4v14M15 6v14" />
        </svg>
      );
  }
}
